/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto } from '../models/Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';
import type { Wealthlane_AwardService_Dtos_UnifiedAward_UnifiedAwardBulkDeleteDto } from '../models/Wealthlane_AwardService_Dtos_UnifiedAward_UnifiedAwardBulkDeleteDto';
import type { Wealthlane_AwardService_Dtos_UnifiedAward_UnifiedAwardBulkPublishDto } from '../models/Wealthlane_AwardService_Dtos_UnifiedAward_UnifiedAwardBulkPublishDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UnifiedAwardService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppUnifiedAwardBulkPublishUnifiedAwards(
requestBody?: Wealthlane_AwardService_Dtos_UnifiedAward_UnifiedAwardBulkPublishDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/unified-award/bulk-publish-unified-awards',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppUnifiedAwardBulkDeleteUnifiedAwards(
requestBody?: Wealthlane_AwardService_Dtos_UnifiedAward_UnifiedAwardBulkDeleteDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_DeleteAward_DeleteAwardValidationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/unified-award/bulk-delete-unified-awards',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
